<template>
  <div>
    <el-carousel :interval="4000" type="card" height="200px">
      <el-carousel-item v-for="image in images" :key="image">
        <h3>{{ image }}</h3>
      </el-carousel-item>
    </el-carousel>
    <div style="text-align: center">
      <el-button size="mini" type="primary" round @click="usersEntryTaxis"
        >Είσοδος μέσω Taxis</el-button
      >
      <el-button size="mini" type="primary" round @click="usersEntryForeign"
        >Είσοδος Αλλοδαπών Χρηστών</el-button
      >
    </div>
  </div>
</template>

<script>
import router from '../router/index'

export default {
  name: 'Welcome',
  data() {
    return {
      images: ['Welcome to Your Vue.js App', 'fdevcf', 'wefcw'],
    }
  },
  computed: {},
  methods: {
    usersEntryTaxis() {
      sessionStorage.setItem('fromGGPS', true)
      router.replace('/login')
    },
    usersEntryForeign() {
      sessionStorage.setItem('fromGGPS', false)
      router.replace('/login')
    },
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.events {
  text-align: left;
  height: 70px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
